import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SAMPLE } from "./type";

export const BulkUploadLead = (file) => async (dispatch) => {
  const data = {
    base_64_file: `${file}`,
  };
  const res = await callWebService(callTypes.post, data, Config.importLead);
  if (res) {
    const { data } = res;
    if (data?.status === 0 || data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const getSampleFileLead = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.sampleDownload
  );
  if (res) {
    const { data } = res;
    const payload = data?.data ?? data?.response?.data ?? null;
    if (payload) {
      dispatch({ type: SAMPLE, payload });
    }
    return data;
  } else {
    return null;
  }
};
